//@ts-check
import React from 'react';
import styled from 'styled-components';

/**
 * @param {object} props
 * @param {string[]} props.values
 */
const BulletList = ({ values }) => {
  return (
    <StyledList>
      {values.map((value) => (
        <li key={value}>{value}</li>
      ))}
    </StyledList>
  );
};

const StyledList = styled.ul`
  margin: 0;
  display: flex;
  flex-direction: column;
  overflow-wrap: anywhere;
  padding-left: var(--spectrum-global-dimension-size-175);
  gap: var(--spectrum-global-dimension-size-100);
`;

export default BulletList;
